import React, { useState } from 'react';

export const WeBuyFAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'How quickly can you close?',
      answer: 'We can close in as little as 7 days if needed. However, we are flexible and can work with your timeline. Most transactions close within 2-4 weeks.'
    },
    {
      question: 'Do you really buy properties in any condition?',
      answer: 'Yes. We buy apartment buildings in any condition, whether they need minor updates or major renovations. You do not need to make any repairs before selling.'
    },
    {
      question: 'What if my building has tenants?',
      answer: 'We buy occupied buildings all the time. We will work with your existing tenants and leases. You do not need to evict anyone or wait for leases to expire.'
    },
    {
      question: 'Are there any fees or commissions?',
      answer: 'No. We do not charge any fees or commissions. There are no hidden costs. The offer we make is what you receive at closing.'
    },
    {
      question: 'How do you determine your offer price?',
      answer: 'We analyze your property based on location, condition, rental income, expenses, and current market conditions. Our offers are fair and based on real market data.'
    },
    {
      question: 'What areas do you buy in?',
      answer: 'We buy apartment buildings nationwide. Contact us regardless of where your property is located and we will let you know if we can help.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Frequently Asked Questions</h2>
          <p className="text-xl text-gray-600">
            Get answers to common questions about selling your apartment building
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-gray-100 transition-colors duration-200"
              >
                <span className="text-xl font-bold pr-8">{faq.question}</span>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-orange-500 flex-shrink-0`}></i>
              </button>
              {openIndex === index && (
                <div className="px-8 pb-6">
                  <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
